import { Controller } from "@hotwired/stimulus";
import { postRequestAndWaitForJobCompletion } from "../../scripts/jobCompletion";
import { translate } from "../../scripts/translate";
import * as TranslationsKeys from "../../scripts/locale/translationsKeys";
import { reloadWithTurbo } from "../../scripts/turboHelper";
import { DestinationTourModel } from "../../scripts/_generated/DestinationTourModel";
import { dialogConfirmationButtonClassName, dialogCancelButtonClassName } from "../../scripts/dialogConstants";

export default class DestinationToursListItemController extends Controller {
    static targets = [];
    static values = {
        toggleTourVisibilityUrl: String,
        copyToBaseUrl: String,
        tour: Object,
        getJobUrl: String,
    };

    readonly getJobUrlValue!: string;
    readonly toggleTourVisibilityUrlValue!: string;
    readonly copyToBaseUrlValue!: string;
    readonly tourValue!: DestinationTourModel;

    connect() {
    }

    toggleTourVisibility(event) {
        const actionButton = $(event.currentTarget);
        const isHidden = this.tourValue.isHidden;

        bootbox.confirm({
            message: `Really make the tour ${isHidden ? "visible" : "invisible"} in the destination?`,
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback: (result) => {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    this.toggleTourVisibilityUrlValue,
                    undefined,
                    this.getJobUrlValue,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    }
                );
            }
        });
    }

    copyToBase(event) {
        const actionButton = $(event.currentTarget);

        bootbox.confirm({
            message: 'Really copy the tour to the base destination?',
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Yes),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback: (result) => {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    this.copyToBaseUrlValue,
                    undefined,
                    this.getJobUrlValue,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    }
                );
            }
        });
    }
}
